<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             icon="la la-tags"
             width="500">
    <template slot="body-content">
      <b-form class="assign-tags-to-items-modal-content" @submit.stop.prevent>
        <div class="form-group">
          <multiselect
            id="feed-select"
            v-model="ms_tag_values"
            :options="auto_complete_tags"
            placeholder="Search or add new tags..."
            track-by="uuid"
            label="name"
            :multiple="true"
            :taggable="true"
            @tag="addNewTag" />
        </div>
        <div class="form-group">
          <div class="d-flex flex-column">
            <ss-checkbox id="replace" v-model="replace">
              Replace Original Tags
            </ss-checkbox>
          </div>
        </div>
      </b-form>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => close(true)">
        Confirm
      </b-button>
      <b-button variant="ss" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `assign-tags-to-items-modal`,
  components: {
    VjsModal,
  },
  mixins: [TaggableModelMixin, VjsModalMixin],
  asyncComputed: {
    feeds: {
      async get() {
        return (await axios.get(`/api/v1/feeds`)).data.data;
      },
      default: [],
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: `Assign Tags`,
    },
  },
  data: () => ({
    replace: false,
  }),
  mounted() {
    this.fetchTags();
  },
  methods: {
    close(confirm) {
      this.close_data = {
        confirm,
        tags: this.ms_tag_values,
        replace: this.replace,
      };
      this.complete();
      this.ms_tag_values = [];
    },
  },
};
</script>
